import { Alert, CardBody, CardFooter, CardHeader } from 'components/v4';
import { keywords, trialEndInstructionBody } from 'pages/tpm/constants';
import { InstructionMessages, TpmCardHeaderContent } from 'pages/tpm';

export const TpmTrialExpired = ({ darkMode }) => (
    <>
        <CardHeader>
            <TpmCardHeaderContent />
        </CardHeader>
        <CardBody py={0} w="full" minW="sm">
            <Alert status="info">
                <InstructionMessages
                    instructionBody={trialEndInstructionBody}
                    darkMode={darkMode}
                    keywords={keywords}
                />
            </Alert>
        </CardBody>
        <CardFooter alignItems="center" justifyContent="center" />
    </>
);
